export default __webpack_public_path__ + "static/media/back.2fbeae17.svg";